import { Component } from '@verndale/core';
import { createPopper } from '@popperjs/core';
import { createFocusTrap } from 'focus-trap';

class Tooltip extends Component {
  setupDefaults() {
    this.dom = {
      $buttons: this.el.querySelectorAll('.tooltip-button'),
      $tooltip: this.el.querySelector('.tooltip'),
      $text: this.el.querySelector('.tooltip__text'),
      $closeButton: this.el.querySelector('.tooltip__close-button')
    };

    this.selectedTooltip = '';
    this.activeClass = 'tooltip-button--active';

    this.tooltipTrap = createFocusTrap(this.dom.$tooltip, {
      escapeDeactivates: true,
      clickOutsideDeactivates: true
    });
  }

  addListeners() {
    this.dom.$buttons.forEach((button) =>
      button.addEventListener('click', (e) => this.handleClick(e))
    );
    this.dom.$tooltip.addEventListener('focusout', this.hide.bind(this));
    this.dom.$closeButton.addEventListener('click', this.hide.bind(this));
  }

  handleClick(e) {
    if (
      this.dom.$tooltip.getAttribute('data-show') &&
      e.target === this.selectedTooltip
    ) {
      this.hide();
    } else {
      this.selectedTooltip = e.target;
      this.tooltip = createPopper(e.target, this.dom.$tooltip, {
        placement: 'top',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8]
            }
          }
        ]
      });
      this.show();
    }
  }

  show() {
    this.selectedTooltip.classList.add(this.activeClass);
    this.dom.$text.innerHTML = this.selectedTooltip.dataset.text;
    this.dom.$tooltip.setAttribute('data-show', 'true');
    this.tooltip.update();
    this.tooltipTrap?.activate?.();
    this.dom.$closeButton.ariaLabel = this.dom.$tooltip?.dataset?.closeLabel;
  }

  hide() {
    this.dom.$tooltip.removeAttribute('data-show');
    this.selectedTooltip.classList.remove(this.activeClass);
    this.tooltipTrap?.deactivate?.();
    this.dom.$text.innerHTML = '';
    this.dom.$closeButton.ariaLabel = this.dom.$tooltip?.dataset?.label;
  }
}

export default Tooltip;
